import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class IdentityCardsApi extends ApiModule {
	constructor() {
		super(ModulesMap.IDENTITY_CARDS, {
			entity: 'identity_cards',
		})
	}
}
